export default {
    'shoppingNote.title': 'Shopping Guide',
} as Record<string, string>;
